import { get } from "shared/lib/api"
import { rejectedXHRPromiseLogger } from "shared/lib/xhr_promise"

const initialState = {
  applets: [],
  services: [],
  recommendedServices: [],
  searchTerm: "",
  appletsLoading: false,
  searchLoading: false,
  hideSuggestions: true,
  shouldLoadMoreApplets: true,
  signedIn: false,
}

const setApplets = applets => {
  return {
    type: "SET_SEARCH_APPLETS",
    applets,
  }
}

const setServices = services => {
  return {
    type: "SET_SEARCH_SERVICES",
    services,
  }
}

const fetchMoreApplets = applets => {
  return {
    type: "FETCH_MORE_APPLETS",
    applets,
  }
}

const setAppletsLoading = isLoading => {
  return {
    type: "TOGGLE_APPLETS_LOADING",
    isLoading,
  }
}

const setSearchLoading = isLoading => {
  return {
    type: "TOGGLE_SEARCH_LOADING",
    isLoading,
  }
}

const setShouldLoadMoreApplets = shouldLoadMoreApplets => {
  return {
    type: "SET_SHOULD_LOAD_APPLETS",
    shouldLoadMoreApplets,
  }
}

const toggleShouldHideSuggestions = shouldHideSuggestions => {
  return {
    type: "HIDE_SUGGESTIONS",
    shouldHideSuggestions,
  }
}

export const setSearchTerm = term => {
  return {
    type: "SET_SEARCH_TERM",
    term,
  }
}

const toggleView = view => {
  return {
    type: "TOGGLE_SEARCH_VIEW",
    view,
  }
}

export const fetchSearchResults = term => dispatch => {
  dispatch(setSearchLoading(true))
  const searchPath = `/search/query/${encodeURIComponent(term)}`

  get(searchPath)
    .then(results => {
      if (results[0].length === 0 && results[1].length === 0) {
        dispatch(toggleShouldHideSuggestions(false))
      } else {
        dispatch(setApplets(results[0]))
        dispatch(setServices(results[1]))
        dispatch(setShouldLoadMoreApplets(true))
        dispatch(toggleShouldHideSuggestions(true))
        dispatch(setSearchLoading(false))
      }
    })
    .catch(
      rejectedXHRPromiseLogger(() => {
        dispatch(setSearchLoading(false))
      })
    )
}

export const loadMoreApplets = (offset, term) => dispatch => {
  dispatch(setAppletsLoading(true))
  const morePath = `/search/more_applets/${encodeURIComponent(term)}/${offset}`

  get(morePath)
    .then(results => {
      results.length
        ? dispatch(fetchMoreApplets(results))
        : dispatch(setShouldLoadMoreApplets(false))
      dispatch(setAppletsLoading(false))
    })
    .catch(
      rejectedXHRPromiseLogger(() => {
        dispatch(setAppletsLoading(false))
      })
    )
}

export default function searchResults(state = initialState, action) {
  switch (action.type) {
    case "SET_SEARCH_APPLETS":
      return {
        ...state,
        applets: action.applets,
      }

    case "SET_SEARCH_SERVICES":
      return {
        ...state,
        services: action.services,
      }

    case "FETCH_MORE_APPLETS":
      return {
        ...state,
        applets: [...state.applets, ...action.applets],
      }

    case "FETCH_MORE_SERVICES":
      return {
        ...state,
        services: [...state.services, ...action.services],
      }

    case "SET_SEARCH_TERM":
      return {
        ...state,
        searchTerm: action.term,
      }

    case "TOGGLE_APPLETS_LOADING":
      return {
        ...state,
        appletsLoading: action.isLoading,
      }

    case "TOGGLE_SEARCH_LOADING":
      return {
        ...state,
        searchLoading: action.isLoading,
      }

    case "SET_SHOULD_LOAD_APPLETS":
      return {
        ...state,
        shouldLoadMoreApplets: action.shouldLoadMoreApplets,
      }

    case "TOGGLE_SEARCH_VIEW":
      return {
        ...state,
        currentSearchView: action.view,
      }

    case "HIDE_SUGGESTIONS":
      return {
        ...state,
        hideSuggestions: action.shouldHideSuggestions,
      }

    default: {
      return state
    }
  }
}
